import React, { useEffect, useState, memo } from 'react';
import { paramCase } from 'change-case';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import { useNavigate } from 'react-router-dom';
// @mui
import { Link, Typography, Autocomplete, InputAdornment } from '@mui/material';
// utils
import axios from '../../../../utils/axios';
// routes
import { PATH_HelpAndCommunication } from '../../../../routes/paths';
// components
import Image from '../../../../components/image';
import Iconify from '../../../../components/iconify';
import { CustomTextField } from '../../../../components/custom-input';
import SearchNotFound from '../../../../components/search-not-found';

// ----------------------------------------------------------------------

export default function BlogPostsSearch() {
    const navigate = useNavigate();

    const [searchPosts, setSearchPosts] = useState('');

    const [searchResults, setSearchResults] = useState([]);

    const handleSearchPosts = async (value) => {
        try {
            setSearchPosts(value);
              
        } catch (error) {
            console.error(error);
        }
    };

    const handleClick = (searchposts) => {
        navigate(PATH_HelpAndCommunication.helpcommunicationsearchpage, { state: { searchposts } });
    };


    //  useEffect(() => {

    //    if (searchPosts !== "")
    //    handleClick(searchPosts);

    //  }, [searchPosts, handleClick]);


    const handleKeyUp = (event) => {

        if (event.key === 'Enter') {
            handleClick(searchPosts);
        }
    };

    const handleSearchClick = () =>
    {
        handleClick(searchPosts);
    }

    return (
        <Autocomplete
            size="small"
            autoHighlight
            options={[]}
            open={false}  // Set open prop to false to hide the options popover
            onInputChange={(event, value) => handleSearchPosts(value)}
            getOptionLabel={(post) => post.title}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            componentsProps={{
                popper: {
                    sx: {
                        width: `280px !important`,
                    },
                },
                paper: {
                    sx: {
                        '& .MuiAutocomplete-option': {
                            px: `8px !important`,
                        },
                    },
                },
            }}
            renderInput={(params) => (
                <CustomTextField
                    {...params}
                    width={220}
                    placeholder="Search..."
                    onKeyUp={handleKeyUp}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <InputAdornment position="end" onClick={() => handleSearchClick()} sx={{ cursor: 'pointer' }}>
                                <Iconify icon="eva:search-fill" sx={{ ml: 1, color: 'text.disabled' }} />
                            </InputAdornment>
                        ),
                    }}
                />
            )}
            clearOnBlur={false} // Add this line to prevent clearing on blur
        />

    );
}
